import { apiPOST } from '../lib/api'
import { EnergyEfficiency, EnergyEfficiencyComment, EnergyEfficiencyLeg } from '../types/Input'

export type FetchEnergyEfficiency = {
  type: 'START_FETCHING_ENERGY_EFFICIENCY'
}
export const START_FETCHING_ENERGY_EFFICIENCY = 'START_FETCHING_ENERGY_EFFICIENCY'
export const startFetchingEnergyEfficiency = (): FetchEnergyEfficiency => ({
  type: START_FETCHING_ENERGY_EFFICIENCY,
})

export type UpdateEnergyEfficiency = {
  type: 'UPDATE_ENERGY_EFFICIENCY'
  payload: EnergyEfficiency
  identifier: string
}
export const UPDATE_ENERGY_EFFICIENCY = 'UPDATE_ENERGY_EFFICIENCY'
export const updateEnergyEfficiency = (
  payload: EnergyEfficiency,
  identifier: string
): UpdateEnergyEfficiency => ({
  type: UPDATE_ENERGY_EFFICIENCY,
  payload,
  identifier,
})

export type EnergyEfficiencyError = {
  type: 'ENERGY_EFFICIENCY_ERROR'
  payload: string
}
export const ENERGY_EFFICIENCY_ERROR = 'ENERGY_EFFICIENCY_ERROR'
export const energyEfficiencyError = (payload: string): EnergyEfficiencyError => ({
  type: ENERGY_EFFICIENCY_ERROR,
  payload,
})

export type CommentSubmitSuccess = {
  type: 'COMMENT_SUBMIT_SUCCESS'
  payload: {
    shiftId: string
    legIndex: number
    comment: EnergyEfficiencyComment
  }
}
export const COMMENT_SUBMIT_SUCCESS = 'COMMENT_SUBMIT_SUCCESS'
export const commentSubmitSuccess = (
  shiftId: string,
  legIndex: number,
  comment: EnergyEfficiencyComment
): CommentSubmitSuccess => ({
  type: COMMENT_SUBMIT_SUCCESS,
  payload: {
    shiftId,
    legIndex,
    comment,
  },
})

export type EnergyEfficiencyAction =
  | FetchEnergyEfficiency
  | UpdateEnergyEfficiency
  | EnergyEfficiencyError
  | CommentSubmitSuccess

export const submitChallenge = async (
  shiftId: string,
  shiftDate: string,
  category: string,
  comment: string,
  leg: EnergyEfficiencyLeg
): Promise<{ success: boolean; error?: string; comment?: EnergyEfficiencyComment }> => {
  try {
    const payload = {
      shiftId,
      shiftDate,
      category,
      comment,
      leg,
    }

    const response: EnergyEfficiencyComment = await apiPOST('energyEfficiency/challenge', payload)

    if (response) {
      return {
        success: true,
        comment: response,
      }
    } else {
      return { success: false, error: 'Unexpected response from server' }
    }
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : 'Failed to submit challenge',
    }
  }
}
